appHost.actions.register({
    // #region Vars
    name: '288a.entity.list',
    // #endregion
    // #region Entry
    async execute(data, params) {
        // #region Entity
        let tEntity = { domain: 'erp', segments: [] };
        {
            if (params.entity) {
                tEntity = { ...params.entity };
            }
            if (params.domainName) {
                tEntity.domain = params.domainName;
            }
            if (params.namespace) {
                tEntity.namespace = params.namespace;
            }
            if (params.entityName) {
                tEntity.segments = [
                    {
                        name: params.entityName,
                    }
                ];
            }
        }
        // #endregion
        // #region Args
        let tArgs = {
            entity: tEntity,
            owner: undefined,
            viewName: params?.viewName ?? "list",
            mode: params?.mode ?? "list",
            args: {
                data: data,
                ...params,
            }
        };
        // #endregion
        // #region Instance
        if (data && data.__g_isproxy) {
            tArgs.owner = data;
        }
        // #endregion
        // #region Debug
        utils.logDebug("action: 288a.entity.list", {
            data: data,
            params: params,
            args: tArgs,
        });
        // #endregion
        // #region Url
        if (params.url && false) {
            //Show
            this.$appHost.router.openWindow(tArgs.viewName ?? 'list');
            //Return
            return this.Ok();
        }
        // #endregion
        // #region Popup
        else {
            let tWindow = {
                variant: params?.w ?? 'popup',
                position: params.l,
                size: params.s ?? 'xlarge',
            };
            if (!this.$appHost.notification.hasOpenWindows()) {
                tWindow.variant = params?.w ?? "slide";
                tWindow.position = params.l ?? "bottom";
                tWindow.size = params.s ?? "large";
            }
            //Show
            let tResult = await this.$appHost.notification.showModal2('g-layout__layout-entity', tArgs, tWindow);
            {
                if (tResult.state !== 1) {
                    return this.Cancel();
                }
            }
            //Finish
            return this.Ok();
        }
        // #endregion
    },
    // #endregion
});
export {};
